export const Logger = {
    debug: () => {},
    info: () => {},
    error: (...args) => console.error(...args),
};

export { init };

function init(logging) {
    if (!logging) return;
    Object.assign(Logger, {
        debug: (...args) => console.log(...args),
        info: (...args) => console.log(...args),
        error: (...args) => console.error(...args),
    });
}
